/**
 * Created by ObadaDarwish on 15/03/2017.
 */
import {Pipe, PipeTransform} from '@angular/core';
import {GlobalService} from '../global.service';
@Pipe({name: 'dateSortTournament'})

export class DateSortTournament implements PipeTransform {
  constructor(public globalService: GlobalService) {
  }

  transform(tournaments: any, activate: boolean): any {
    // let globalService:GlobalService;
    if (activate) {
      if (tournaments) {
        let currentDate = new Date().getTime();
        let WaitingPlayersArray: Array<any> = [];
        let InProgressArray: Array<any> = [];
        let FinishedArray: Array<any> = [];
        let RegistrationClosed: Array<any> = [];
        let AllTournaments;
        //waiting players to join tournaments
        for (let tournament = 0; tournament < tournaments.length; tournament++) {
          if (tournaments[tournament].status == 'Waiting Players to Join') {
            WaitingPlayersArray.push(tournaments[tournament])
          }
        }
        // divide 'WaitingPlayersArray' tournaments to preCurrentDate and pastCurrentDate tournaments according to their timestamp
        let preCurrentDate: Array<any> = [];
        let pastCurrentDate: Array<any> = [];
        WaitingPlayersArray.forEach((tournament, index)=> {
          if (tournament.start_at > currentDate)
            pastCurrentDate.push(tournament);
          else
            preCurrentDate.push(tournament);
        });
        // sort past current date
        pastCurrentDate=this.descSort(pastCurrentDate);
        // sort pre current date
        preCurrentDate=this.ascSort(preCurrentDate);
        WaitingPlayersArray = [];
        WaitingPlayersArray = WaitingPlayersArray.concat(pastCurrentDate, preCurrentDate);
//registration closed tournaments
        for (let tournament = 0; tournament < tournaments.length; tournament++) {
          if (tournaments[tournament].status == 'Registration Closed') {
            RegistrationClosed.push(tournaments[tournament])
          }
        }
        RegistrationClosed=this.ascSort(RegistrationClosed);
//in progress tournaments
        for (let tournament = 0; tournament < tournaments.length; tournament++) {
          if (tournaments[tournament].status == 'In Progress') {
            InProgressArray.push(tournaments[tournament])
          }
        }
        InProgressArray=this.ascSort(InProgressArray);

        //finished tournaemnts
        for (let tournament = 0; tournament < tournaments.length; tournament++) {
          if (tournaments[tournament].status == 'Finished') {
            FinishedArray.push(tournaments[tournament])
          }
        }
        FinishedArray=this.ascSort(FinishedArray);
        AllTournaments = WaitingPlayersArray.concat(RegistrationClosed, InProgressArray, FinishedArray);

        return AllTournaments;
      }
    }
    else {
      return tournaments;
    }
  }

  ascSort(tournaments){
  return tournaments.sort(function (tournamentA, tournamentB) {
    let dateA = tournamentA.start_at;
    let dateB = tournamentB.start_at;
    if (dateA > dateB) {
      return -1;
    } else if (dateA < dateB) {
      return 1;
    } else {
      return 0;
    }
  });
}
  descSort(tournaments){
    return tournaments.sort(function (tournamentA, tournamentB) {
      let dateA = tournamentA.start_at;
      let dateB = tournamentB.start_at;
      if (dateA > dateB) {
        return 1;
      } else if (dateA < dateB) {
        return -1;
      } else {
        return 0;
      }
    });
  }

}
